import { Theme } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React from 'react';

export interface IMediaQueryMatch {
	mediaQueryMatches: boolean;
}

/**
 * To use useMediaQuery hook in class based components
 * @param WrappedComponent Component which will use useMediaQuery hook
 * @returns WrappedComponent with useMediaQuery props
 */
const withMediaQueries = <P extends IMediaQueryMatch>(
	WrappedComponent: React.ComponentType<P>,
	queryFunc: (theme: Theme) => string
): React.ComponentType<Omit<P, keyof IMediaQueryMatch>> => {
	return (props) => {
		const matches = useMediaQuery(queryFunc);
		return <WrappedComponent {...(props as P)} mediaQueryMatches={matches} />;
	};
};

export default withMediaQueries;



// WEBPACK FOOTER //
// ./src/providers/media-query.provider.tsx